import { PaginationModel } from '@cv-invision/cv.component-library.ux';
import { SmartQCModel } from './state-status.model';
import { TrackingClientFilter } from './tracking-client.model';
import { QueueModel } from './queues.model';

export class InboxFilterForm {
	address?: string;
	orderStates?: Array<any>;
	startDate?: Date;
	endDate?: Date;
	profileSelected?: any;
	pagination?: PaginationModel;
	referenceID?: string;
	ssrFilterOrders?: any;
	formType?: Array<any>;
	clientName?: string;
	smartQC: Array<{ id: number; name: SmartQCModel }>;
	trackingClients: TrackingClientFilter;
	queues: Array<QueueModel> | undefined;

	constructor() {
		this.address = '';
		this.orderStates = [];
		this.startDate = undefined;
		this.endDate = undefined;
		this.profileSelected = {};
		this.pagination = new PaginationModel();
		this.referenceID = undefined;
		this.ssrFilterOrders = {};
		this.formType = [];
		this.clientName = '';
		this.smartQC = [];
		this.trackingClients = { trackingId: '', clients: [] };
		this.queues = undefined;
	}
}
